import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useLocalMediaActions } from '../useLocalMedia/useLocalMediaActions';
import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';

/**
 * Hook that automatically stops local media (camera/microphone) when navigating
 * to pages that don't need video, except for call and dashboard pages.
 *
 * This provides centralized camera control for all account pages.
 */

const withVideoPaths = [
  getPublicRuntimeConfig().paths.call,
  getPublicRuntimeConfig().paths.dashboard,
];

export const useStopLocalMediaBasedOnRoute = (): void => {
  const { stop } = useLocalMediaActions();
  const router = useRouter();

  useEffect(() => {
    if (!withVideoPaths.includes(router.pathname)) {
      void stop();
    }
  }, [router.pathname]);
};
